var map = {
	"./en/p1-B-B.png": 896,
	"./en/p1-B.png": 897,
	"./en/p1.png": 898,
	"./en/p10.png": 899,
	"./en/p11.png": 900,
	"./en/p13-B.png": 901,
	"./en/p13.png": 902,
	"./en/p14.png": 903,
	"./en/p2.png": 904,
	"./en/p3.png": 905,
	"./en/p4.png": 906,
	"./en/p5-B.png": 907,
	"./en/p5.png": 908,
	"./en/p6.png": 909,
	"./en/p7.png": 910,
	"./en/p8.png": 911,
	"./en/p9.png": 912,
	"./ja/p1-B-B.png": 913,
	"./ja/p1-B.png": 914,
	"./ja/p1.png": 915,
	"./ja/p10.png": 916,
	"./ja/p11.png": 917,
	"./ja/p13-B.png": 918,
	"./ja/p13.png": 919,
	"./ja/p14.png": 920,
	"./ja/p2.png": 921,
	"./ja/p3.png": 922,
	"./ja/p4.png": 923,
	"./ja/p5-B.png": 924,
	"./ja/p5.png": 925,
	"./ja/p6.png": 926,
	"./ja/p7.png": 927,
	"./ja/p8.png": 928,
	"./ja/p9.png": 929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;